<header-nav 
    layoutType="horizontal"
    [color]="headerNavColor"
    [isMobile]="isMobile"
></header-nav>
<header-navbar *ngIf="!isMobile" [color]="navMenuColor"></header-navbar>
<mobile-nav *ngIf="isMobile" [isOpen]="isMobileNavOpen" [color]="navMenuColor"></mobile-nav>
<content layoutType="horizontal"></content>

